import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { CmsDataProject } from 'src/app/models/cmsdata';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'artist-preview',
  templateUrl: './preview.component.html',
  styleUrls: ['./preview.component.scss']
})
export class PreviewComponent implements OnInit {

  @Input()
  public project: CmsDataProject;

  @Input()
  public modalCloseUrl: string = "";

  constructor(
    private router: Router,
    private utilService: UtilService
  ) { }

  ngOnInit(): void {
  }

  clickProject($event: any) {
    $event.preventDefault();
    this.router.navigate([`/map/artist/${this.project.project_slug}`]);
    this.utilService.modalCloseUrl.next(this.modalCloseUrl);
  }

}
